import { mapPagination } from '@/shared/mappers';
import { DataWithPagination, Page } from '@/shared/types';
import {
  CompanyAutomationsPerforrmance,
  CompanyModel,
  UserCompany,
} from '../domain';
import {
  ApiResponseCompanies,
  CompanyAutomationPerformanceJson,
  CompanyJson,
  PagedCompanies,
  UserCompanyJson,
} from '../types';

export const companyMapper = (companyJson: CompanyJson): CompanyModel => ({
  id: companyJson?.id ?? 0,
  organizationId: companyJson?.organizationId ?? 0,
  organizationName: companyJson?.organizationName ?? '',
  name: companyJson?.name ?? '',
  code: companyJson?.code ?? '',
  nif: companyJson?.nif ?? '',
  status: companyJson?.status ?? false,
  address: {
    id: companyJson?.address?.id ?? 0,
    line1: companyJson?.address?.line1 ?? '',
    line2: companyJson?.address?.line2 ?? '',
    city: companyJson?.address?.city ?? '',
    country: companyJson?.address?.country ?? '',
    postalCode: companyJson?.address?.postalCode ?? '',
  },
  usersCount: companyJson?.usersCount ?? 0,
  businessAreasCount: companyJson?.businessAreasCount ?? 0,
  processesCount: companyJson?.processesCount ?? 0,
  tasksCount: companyJson?.tasksCount ?? 0,
  automationsCount: companyJson?.automationsCount ?? 0,
  infrastructureCostsCount: companyJson?.infrastructureCostsCount ?? 0,
  predictedManualTime: companyJson?.predictedManualTime ?? 0,
  predictedAverageManualTime: companyJson?.predictedAverageManualTime ?? 0,
  automationRunTime: companyJson?.automationRunTime ?? 0,
  averageAutomationRunTime: companyJson?.averageAutomationRunTime ?? 0,
  totalInvestment: companyJson?.totalInvestment ?? 0,
  totalReturn: companyJson?.totalReturn ?? 0,
  averageCost: companyJson?.averageCost ?? 0,
  averageManualCost: companyJson?.averageManualCost ?? 0,
  jiraLink: companyJson?.jiraLink ?? '',
  workflowsCount: companyJson?.workflowsCount ?? 0,
  profileImageFileId: companyJson?.profileImageFileId,
  canDelete: companyJson?.canDelete ?? false,
  totalExecutions: companyJson?.totalExecutions ?? 0,
  adminsCount: companyJson?.adminsCount ?? 0,
});

export const companiesWithPaginationMapper = (
  companiesJson: ApiResponseCompanies<PagedCompanies>,
) => {
  const { data } = companiesJson;
  return {
    items: companiesMapper(data.companies.items),
    ...mapPagination(data.companies),
  };
};

export const companiesMapper = (
  companiesJson: Array<CompanyJson>,
): Array<CompanyModel> => companiesJson.map(companyMapper);

export const companyAutomationsPerformanceMapper = (
  companyAutomationsPerformanceJson: CompanyAutomationPerformanceJson,
): CompanyAutomationsPerforrmance => ({
  predictedManualTime:
    companyAutomationsPerformanceJson?.predictedManualTime ?? 0,
  automationRunTime: companyAutomationsPerformanceJson?.automationRunTime ?? 0,
  totalExecutions: companyAutomationsPerformanceJson?.totalExecutions ?? 0,
  totalReturn: companyAutomationsPerformanceJson?.totalReturn ?? 0,
  averageCost: companyAutomationsPerformanceJson?.averageCost ?? 0,
  totalInvestment: companyAutomationsPerformanceJson?.totalInvestment ?? 0,
});

export const userCompanyMapper = (company: UserCompanyJson): UserCompany => ({
  id: company.id ?? 0,
  name: company.name ?? '',
  status: company.status ?? false,
  code: company.code ?? '',
  roles: company.roles ?? [],
  usersCount: company.usersCount ?? 0,
  businessAreasCount: company.businessAreasCount ?? 0,
  processesCount: company.processesCount ?? 0,
  automationsCount: company.automationsCount ?? 0,
  organizationId: company.organizationId ?? 0,
  profileImageFileId: company.profileImageFileId,
});

export const userCompanyPageMapper = (
  page: Page<UserCompanyJson>,
): DataWithPagination<UserCompany[]> => ({
  items: page.items.map(userCompanyMapper),
  ...mapPagination(page),
});
